import React, { useState } from "react";
import { Dropdown } from "react-bootstrap";
import "./dropDown.css";
import DropdownArrow from "../../assets/images/dropdownArrow.svg";

const DropDownItem = ({
  list,
  selectedItem,
  setSelectedItem,
  categoryRequired,
  onDropdownChange,
}) => {
  const [showDropdownList, setShowDropdownList] = useState(false);

  return (
    <Dropdown
      className={
        categoryRequired == false ? "drop-item" : "drop-item error-alert"
      }
      align="end"
    >
      <Dropdown.Toggle variant="secondary" id="dropdown-basic">
        {selectedItem && selectedItem?.name ? selectedItem.name : selectedItem}
      </Dropdown.Toggle>

      <Dropdown.Menu>
        {list?.map((item, index) => {
          return (
            <Dropdown.Item
              href="#/action-1"
              key={index}
              onClick={(e) => {
                e.preventDefault();
                setSelectedItem(item), setShowDropdownList(false);
                onDropdownChange && onDropdownChange(item);
              }}
            >
              {item?.name}
            </Dropdown.Item>
          );
        })}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default DropDownItem;
